<template>
  <div>
    <vxe-card size="mini" width="100%">
      <template #title>
        <vxe-select v-model="query['storer.id']" :options="storers" clearable placeholder="placeholder.pleaseSelectStorer" @change="refresh"/>
        <vxe-input v-model="query['order.no']" clearable placeholder="placeholder.orderNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['command.id']" clearable placeholder="placeholder.transferBarcode" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['item.barcode']" clearable placeholder="placeholder.itemBarcode" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['item.no']" clearable placeholder="placeholder.itemNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['item.name']" clearable placeholder="placeholder.itemName" @clear="refresh" @keydown.native.enter="refresh"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
        <vxe-button content="button.shelfConfirm" icon="vxe-icon-send" status="primary" @click="putaway"/>
        <vxe-button v-show="false" content="button.cancelPutAway" icon="vxe-icon-undo" status="danger" @click="cancel"/>
      </template>
      <vxe-table
        ref="table"
        :checkbox-config="{trigger: 'row'}"
        :column-config="{resizable: true}"
        :data="data"
        :export-config="{}"
        :height="height"
        :keyboard-config="{isArrow: true}"
        :loading="loading"
        :row-config="{isCurrent: true, isHover: true}"
        :scroll-x="{enabled: true}"
        align="center"
        border
        round
        show-header-overflow
        show-overflow
        size="mini"
        stripe>
        <vxe-column fixed="left" type="checkbox" width="30"/>
        <vxe-column field="order.no" title="business.label.orderNo" width="120"/>
        <vxe-column field="item.no" title="business.label.itemNo" width="80"/>
        <vxe-column field="item.name" title="business.label.itemName"/>
        <vxe-column field="pack.specification" title="business.label.specification"/>
        <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
        <vxe-column field="pack.factor" title="business.label.packageNumber"/>
        <vxe-column field="lot.no" title="business.label.lot"/>
        <vxe-column field="batch.no" title="business.label.batchNo"/>
        <vxe-column field="lot.manufacturer" title="business.label.manufacturer"/>
        <vxe-column field="sourceLocation.no" title="business.label.sourceLocation"/>
        <vxe-column field="command.quantity" title="business.label.quantity"/>
        <vxe-column field="targetLocation.no" title="business.label.moveInLocation"/>
        <vxe-column field="reason.name" title="business.label.reason"/>
        <vxe-column field="storer.name" title="business.label.storerName" width="120"/>
        <vxe-column field="sourceContainer.no" title="business.label.sourceContainer"/>
        <vxe-column field="targetContainer.no" title="business.label.targetContainer"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:inventoryStates}" field="command.inventoryState" title="business.label.inventoryState"/>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
      </template>
    </vxe-card>
  </div>
</template>

<script>
import { findAll, findEnum, post } from '@/api/Api'
import Api from '@/api'
import api from '@/api'
import Vue from 'vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'

export default {
  name: 'TransferCommandPutaway',
  data() {
    return {
      data: [],
      storers: [],
      inventoryStates: [],
      page: 1,
      size: 20,
      contentSize: 0,
      loading: false,
      query: {
        'command.id': '',
        'order.no': '',
        'item.no': '',
        'item.name': '',
        'item.barcode': '',
        'storer.id': undefined
      },
      height: Vue.ls.get(SCREEN_HEIGHT) * (0.8)
    }
  },
  created() {
    Promise.all([
      findAll('storerFactory', { available: true }).then(res => {
        if (res.success) {
          this.storerData = res.result.map(item => {
            return { label: item.name, value: item.id }
          })
        }
      }),
      findEnum('InventoryState').then(res => {
        if (res.success) {
          this.inventoryStates = res.result.map(item => {
            return { label: item.name, value: item.ordinal }
          })
        }
      })
    ]).then(() => this.refresh())
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      this.loading = true
      findAll('transferCommandPutawayFactory', this.query, this.page, this.size).then((res) => {
        if (res.success) {
          this.contentSize = res.contentSize
          this.data = res.result
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    reset() {
      this.query = {
        'command.id': '',
        'order.no': '',
        'item.no': '',
        'item.name': '',
        'item.barcode': '',
        'storer.id': undefined
      }
      this.refresh()
    },
    putaway() {
      const selectedRows = this.$refs.table.getCheckboxRecords()
      if (selectedRows.length === 0) {
        this.$message.error('请选择要上架的任务')
        return
      }
      this.loading = true
      post(Api.transferPutaway, { type: 'commandExecutor' }, { ids: selectedRows.map(item => item.command.id) }).then(res => {
        if (res.success) {
          this.fetch()
          this.$message.success('上架成功')
        }
      }).finally(() => this.loading = false)
    },
    cancel() {
      const selectedRows = this.$refs.table.getCheckboxRecords()
      if (selectedRows.length === 0) {
        this.$message.error('请选择要取消上架的任务')
        return
      }
      this.loading = true
      const promiseArr = []
      selectedRows.forEach(item => {
        promiseArr.push(new Promise(resolve => {
          post(api.transferCancel, {}, { 'order.id': item.order.id }).then(() => {
            resolve()
          })
        }))
      })
      Promise.all(promiseArr).then(() => {
        this.fetch()
        this.$message.success('已取消上架')
      }).finally(() => this.loading = false)
    }
  }
}
</script>